// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3crdl","questions":"styles_questions__2HanI","footer":"styles_footer__28ltO"};